module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-453.3113eae.woff2";